#import "@/apollo/fragments/MasterTemplate.gql"

mutation UpdateResizedTemplate($masterTemplateId: ID!, $parentId: ID!) {
    updateResizedMasterTemplate(masterTemplateId: $masterTemplateId, parentId: $parentId) {
        ...MasterTemplate
        parentId
        parentWidth
        parentHeight
    }
}
